import { useQuery } from 'react-fetching-library';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import selectors from '../../store/selectors';

const fetchMassList = (accountId, dateTo) => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/masses?${new URLSearchParams({
    from: moment().format('YYYY-MM-DD'),
    to: dateTo,
    devotionType: 'standard_mass',
  }).toString()}`,
});

const actions = {
  loading: () => ({
    type: 'fetch/masses/loading',
  }),
  finished: () => ({
    type: 'fetch/masses/finished',
  }),
  fail: error => ({
    type: 'fetch/masses/fail',
    payload: error,
  }),
  saveData: payload => ({
    type: 'masses/saveData',
    payload,
  }),
};

export const useFetchMasses = accountId => {
  const massOfferingMassRequestToDate = useSelector(selectors.getMassOfferingMassRequestToDate);
  const { loading, payload, error, query } = useQuery(
    fetchMassList(accountId, massOfferingMassRequestToDate),
    false,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!!massOfferingMassRequestToDate) {
      query();
    }
  }, [massOfferingMassRequestToDate]);

  useEffect(() => {
    if (loading) {
      dispatch(actions.loading());
    } else if (error) {
      dispatch(actions.fail(error));
    } else if (!!payload) {
      dispatch(actions.finished());
      dispatch(actions.saveData(payload));
    }
  }, [loading, error, payload]);
};
